import {
  Card,
  CardActionArea,
  CardContent,
  Theme,
  Typography,
} from '@material-ui/core';
import { ColorDynamic } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { AddLoadAlertIcon } from 'shared/icons/AddLoadAlertIcon';
import styled, { css } from 'styled-components';

const Main = styled(Card)(
  ({ theme }: { theme: Theme }) => css`
    border-style: dashed;

    & .MuiCardContent-root {
      padding: 34px 16px 24px 16px;
      color: ${ColorDynamic.Silver500};

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    & .MuiTypography-gutterBottom {
      margin-bottom: ${theme.spacing(2)}px;
    }
  `,
);

interface SavedSearchEmptyCardProps {
  onAddClick: () => void;
}

export function SavedSearchEmptyCard({
  onAddClick,
}: SavedSearchEmptyCardProps) {
  return (
    <Main
      role="button"
      aria-label="Create Load Alert Empty Card"
      onClick={onAddClick}
    >
      <CardActionArea>
        <CardContent>
          <Button
            variant="text"
            startIcon={<AddLoadAlertIcon color="primary" />}
          >
            Create Load Alert
          </Button>

          <Typography variant="h5" color="textSecondary" align="center">
            Create load alert and be notified <br />
            when a load is posted.
          </Typography>
        </CardContent>
      </CardActionArea>
    </Main>
  );
}
